import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';

@Component({
    selector: 'thirdlevel-navigation',
    templateUrl: 'thirdlevel-navigation.component.html'
})
export class ThirdLevelComponent implements OnInit, OnDestroy {
    thirdNavLinks: any[];
    selectedThirdPageId: any;
    navigation: NxiNavigation;
    layout: string;
    alertsSigned: any;
    serviceUrl: string;
    titleValueArray: string[];
    titleValue: string;

    constructor(
        private http: HttpClient,
        private translationService: PershingTranslationService,
        private navigationService: PortalNavigationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.navigationService.getChildPage().subscribe(
            currentpage => {
                if (currentpage !== undefined && currentpage.children !== undefined) {
                    this.thirdNavLinks = currentpage.children;
                    for (let i = 0; i < this.thirdNavLinks.length; i++) {
                        if (this.thirdNavLinks[i].istitle === undefined) {
                            this.selectedThirdPageId = this.thirdNavLinks[i].id;
                            this.layout = this.thirdNavLinks[i].layout;
                            break;
                        }
                    }
                }
            });
        this.navigationService.getGrandChildPage().subscribe(
            grandchildpage => {
                if (grandchildpage) {
                    if (grandchildpage.istitle === undefined) {
                        this.selectedThirdPageId = grandchildpage.id;

                    }
                }
                this.alertsSigned = window['NXIF2Container']?.alertsSigned;
                console.log(' 3rd grandchildpage-- ' + this.selectedThirdPageId);
                console.log(' 3rd grandchildpage alertsSigned-- ' + this.alertsSigned);
            }
        );
    }
    ngOnInit(): void {
        console.log(' In Component OnInit ');
    }

    public ngOnDestroy() {
        console.log(' In thirdlevelComponent Destroy ');
    }

    handleThirdLevelNavigation(grandchildpage): void {
        if (grandchildpage && grandchildpage.id  === 'marketalerts' ) {
            this.gotoPageEvent('/nxi/research/investtools/marketalerts/securitiesalerts');
        } else if (grandchildpage && grandchildpage.id  === 'sectorindustry') {
            this.gotoPageEvent('/nxi/research/markets/sectorindustry/sectorindusperformance');
        } else {
            this.navigation = new NxiNavigation();
            this.navigation.grandchildPage = grandchildpage;
            this.navigationService.handleNavigation(this.navigation);
        }
    }

    gotoPageEvent(gotoPageName): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': gotoPageName
            }
        }));
    }
}
